import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "./Firebase";

const AddProject = ({ onClose }) => {
  const [form, setForm] = useState({
    title: "",
    description: "",
    image: "",
    demoLink: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "projects"), form);
      alert("Project Added!");
      setForm({ title: "", description: "", image: "", demoLink: "" });
    } catch (err) {
      console.error("Error adding project:", err);
    }
  };

  return (
    <div id="add-project" className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="relative w-full max-w-md p-6 mx-auto bg-gray-900 rounded-lg shadow-2xl">
        <button
          onClick={onClose}
          className="absolute text-2xl font-bold text-gray-400 top-2 right-2 hover:text-teal-400 focus:outline-none"
          aria-label="Close"
        >
          &times;
        </button>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-4"
        >
          <h2 className="mb-2 text-2xl font-bold text-white">Add New Project</h2>
          <input
            type="text"
            name="title"
            placeholder="Title"
            value={form.title}
            onChange={handleChange}
            className="w-full p-2 text-black rounded"
            required
          />
          <textarea
            name="description"
            placeholder="Description"
            value={form.description}
            onChange={handleChange}
            className="w-full p-2 text-black rounded"
            required
          />
          <input
            type="text"
            name="image"
            placeholder="Image URL"
            value={form.image}
            onChange={handleChange}
            className="w-full p-2 text-black rounded"
            required
          />
          <input
            type="text"
            name="demoLink"
            placeholder="Demo Link"
            value={form.demoLink}
            onChange={handleChange}
            className="w-full p-2 text-black rounded"
            required
          />
          <button
            type="submit"
            className="w-full py-2 font-bold text-white bg-teal-600 rounded hover:bg-teal-700"
          >
            Add Project
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddProject;
